export default "<div class=\"ccc-label align-start\">\n  <label class=\"label\"></label>\n</div>\n";